// extracted by mini-css-extract-plugin
export default {"text-input":"TextInput_text-input__ZjzWT","error-red":"TextInput_error-red__x5K62","error-white":"TextInput_error-white__Qp6XF","border-red":"TextInput_border-red__hbVsF"};